import { Formik, Form, ErrorMessage } from "formik";
import * as yup from "yup";
import { Button } from "primereact/button";
import { CheckDuplicate } from "components/CheckDuplicate";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import { Title } from "components/Title";
import useApp from "hooks/useApp";
import { useTranslation } from "react-i18next";
import useAddPage from "hooks/useAddPage";
const OrgAddPage = (props) => {
  const app = useApp();
  const { t } = useTranslation();
  //form validation rules
  const validationSchema = yup.object().shape({
    code: yup.string().required(t("CODE_REQUIRED")),
    name: yup.string().required(t("NAME_REQUIRED")),
    contact_info: yup.string().required(t("CONTACT_INFORMATION_REQUIRED")),
  });

  //form default values
  const formDefaultValues = {
    code: "",
    name: "",
    contact_info: "",
  };
  // const CREATE_FACILITY = t("CREATE_FACILITY");
  const CODE = t("CODE");
  const NAME = t("NAME");
  const ENTER_CODE = t("ENTER_CODE");
  const ENTER_NAME = t("ENTER_NAME");
  const ENTER_CONTACT_INFORMATION = t("ENTER_CONTACT_INFORMATION");
  const SUBMIT = t("SUBMIT");
  const RESET = t("RESET");
  const CONTACT_INFORMATION = t("CONTACT_INFORMATION");

  //page hook where logics resides
  const pageController = useAddPage({ props, formDefaultValues, afterSubmit });

  // destructure and grab what the page needs
  const {
    formData,
    resetForm,
    handleSubmit,
    submitForm,
    pageReady,
    loading,
    saving,
    inputClassName,
  } = pageController;

  //event raised after form submit
  function afterSubmit(response) {
    app.flashMsg(props.msgTitle, props.msgAfterSave);
    resetForm();
    app.getAllOrganisations();
    if (app.isDialogOpen()) {
      app.closeDialogs(); // if page is open as dialog, close dialog
    } else if (props.redirect) {
      app.navigate(`/org`);
    }
  }
  const handleReset = (formik) => {
    formik.resetForm();
  };
  const getInputClassName = (error, touched) => {
    return error && touched ? "p-invalid" : "";
  };
  // page loading form data from api
  if (loading) {
    return (
      <div className="p-3 text-center">
        <ProgressSpinner style={{ width: "50px", height: "50px" }} />
      </div>
    );
  }

  //page has loaded any required data and ready to render
  if (pageReady) {
    return (
      <main id="OrgAddPage" className="main-page">
        {props.showHeader && (
          <section className="page-section mb-3">
            <div className="container">
              <div className="grid align-items-center">
                {!props.isSubPage && (
                  <div className="col-fixed ">
                    <Button
                      onClick={() => app.navigate(-1)}
                      label=""
                      className="p-button p-button-text "
                      icon="pi pi-arrow-left"
                    />
                  </div>
                )}
                <div className="col ">
                  <Title
                    title={props.msgTitle}
                    titleClass="text-2xl text-primary font-bold"
                    subTitleClass="text-500"
                    separator={false}
                  />
                </div>
              </div>
            </div>
          </section>
        )}
        <section className="page-section ">
          <div className="container">
            <div className="grid ">
              <div className="md:col-9 sm:col-12 comp-grid">
                <div>
                  <Formik
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={(values, actions) => submitForm(values)}
                  >
                    {(formik) => (
                      <>
                        <Form className={`${!props.isSubPage ? "card  " : ""}`}>
                          <div className="grid">
                            <div className="col-12">
                              <div className="formgrid grid">
                                <div className="col-12 md:col-3">{CODE} *</div>
                                <div className="col-12 md:col-9">
                                  <CheckDuplicate
                                    value={formik.values.code.toUpperCase()}
                                    apiPath="org/get_org"
                                  >
                                    {(checker) => (
                                      
                                        <>
                                          <InputText
                                            name="code"
                                            onBlur={(e) => {
                                              formik.setFieldValue(
                                                "code",
                                                e.target.value.toUpperCase()
                                              );
                                              checker.check();
                                            }}
                                            onChange={formik.handleChange}
                                            value={formik.values.code.toUpperCase()}
                                            label="Code"
                                            type="text"
                                            placeholder={ENTER_CODE}
                                            className={getInputClassName(
                                              formik.errors.code,
                                              formik.touched.code
                                            )}
                                            style={{ width: "100%" }}
                                          />
                                          <ErrorMessage
                                            name="code"
                                            component="span"
                                            className="p-error"
                                          />
                                          {!checker.loading &&
                                            checker.exist && (
                                              <small className="p-error">
                                                {t("ALREADY_EXISTS")}
                                              </small>
                                            )}
                                          {checker.loading && (
                                            <small className="text-500">
                                              {t("CHECKING")}
                                            </small>
                                          )}
                                        </>
                                      )
                                    }
                                  </CheckDuplicate>
                                  {/* <InputText name="code" onChange={formik.handleChange} value={formik.values.code} label="Code" type="text" placeholder="Enter Code" className={inputClassName(formik?.errors?.code)} />
                                 <ErrorMessage name="code" component="span" className="p-error" /> */}
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="formgrid grid">
                                <div className="col-12 md:col-3">{NAME} *</div>
                                <div className="col-12 md:col-9">
                                  <InputText
                                    name="name"
                                    onChange={formik.handleChange}
                                    value={formik.values.name}
                                    label="Name"
                                    type="text"
                                    placeholder={ENTER_NAME}
                                    className={getInputClassName(
                                      formik.errors.name,
                                      formik.touched.name
                                    )}
                                    style={{ width: "100%" }}
                                  />
                                  <ErrorMessage
                                    name="name"
                                    component="span"
                                    className="p-error"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="formgrid grid">
                                <div className="col-12 md:col-3">
                                  {CONTACT_INFORMATION} *
                                </div>
                                <div className="col-12 md:col-9">
                                  <InputText
                                    name="contact_info"
                                    onChange={formik.handleChange}
                                    value={formik.values.contact_info}
                                    label="Contact Information"
                                    type="text"
                                    placeholder={ENTER_CONTACT_INFORMATION}
                                    className={getInputClassName(
                                      formik.errors.contact_info,
                                      formik.touched.contact_info
                                    )}
                                    style={{ width: "100%" }}
                                  />
                                  <ErrorMessage
                                    name="contact_info"
                                    component="span"
                                    className="p-error"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {props.showFooter && (
                            <div className="text-center my-3">
                              <Button
                                onClick={(e) => handleSubmit(e, formik)}
                                className="mr-2"
                                type="submit"
                                label={SUBMIT}
                                icon="pi pi-send"
                                loading={saving}
                              />
                              <Button
                                onClick={() => handleReset(formik)}
                                className="p-button-secondary mr-2"
                                type="button"
                                label={RESET}
                                icon="pi pi-refresh"
                              />
                            </div>
                          )}
                        </Form>
                      </>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
};

const withDefaultProps = (Component) => {
  const WrappedComponent = (props) => {
    const { t } = useTranslation();
    const defaultProps = {
      primaryKey: "id",
      pageName: "org",
      apiPath: "org/add_org",
      routeName: "orgadd",
      submitButtonLabel: "Submit",
      formValidationError: t("FORM_IS_INVALID"),
      formValidationMsg: t("PLEASE_COMPLETE_THE_FORM"),
      msgTitle: t("CREATE_FACILITY"),
      msgAfterSave: t("FACILITY_CREATED_SUCCESSFULLY"),
      msgBeforeSave: "",
      showHeader: true,
      showFooter: true,
      redirect: true,
      isSubPage: false,
    };

    return <Component {...defaultProps} {...props} />;
  };

  return WrappedComponent;
};

export default withDefaultProps(OrgAddPage);
